export class WebgisUrlParameter {
  private _name: string;
  private value: string;

  constructor(name: string, value: string) {
    this._name = name;
    this.value = value;
  }

  addParameterNameSuffix(suffix: string) {
    this._name = suffix + this._name;
  }

  set name(name: string) {
    this._name = name;
  }

  compositedNameAndValue() {
    return `${this._name}=${this.value}`;
  }
}
